export default function(loading) {
    return (loading ? 'fa fa-spinner fa-spin':"fa fa-user")
}


// WEBPACK FOOTER //
// ./src/utils/constants/userIcon.js